import { Injectable } from "@angular/core";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { PolarisEntityCollectionServiceBase } from "../shared/services/polaris-entity-collection-service-base.service";
import { ListingAudit } from "./listing-audit";

@Injectable({
	providedIn: "root",
})
export class ListingAuditService extends PolarisEntityCollectionServiceBase<ListingAudit> {
	constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
		super("ListingAudit", serviceElementsFactory);
	}
}
